module.exports = __webpack_public_path__ + "assets/img/bubble.dec3208d.png";